import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CRV } from 'services/_path';
import { Types } from './types';
import {
	consultaUnidadeTransitoSuccess,
	consultaUnidadeTransitoFailure,
} from './actions';

function* consultaUnidadeTransitoRequest(request: {
	type: string;
	payload: any;
}) {
	const { payload } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`consultas/${CHANNEL}/consulta-unidade-transito`,
		payload,
	);
	if (response.status === 200 || response.status === 201) {
		yield put(consultaUnidadeTransitoSuccess(response));
	} else if (response.error) {
		yield put(consultaUnidadeTransitoFailure(response.message));
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_UNIDADE_TRANSITO_REQUEST,
		consultaUnidadeTransitoRequest,
	),
]);
